<template>
    <div>
        <data-list :dataCols="dataCols"
                   :dataListItems="dataListItems"
                   :tableClass="tableClass"
                   :showCheckbox="showCheckbox"
                   :actions="actions"
                   :iconFuncs="iconFuncs"
                   @change="handleSelectedItemsChange"
                   @sgl-click="handleItemSglClick"
                   @dbl-click="handleItemDblClick"
                   @action-click="handleActionClick"
                   @column-click="handleSortClick" />

        <b-pagination v-if="showPagination"
                      align="center"
                      :total-rows="getTotalRecords"
                      :per-page="getPageSize"
                      :size="'sm'"
                      @input="handlePagenationInput"
                      v-model="selectedPageNumber"/>

    </div>
</template>

<script>

import DataList from '@/components/DataList.vue'
export default {
  name: 'DataListPagination',
  props: {
    dataCols: Array,
    dataListItems: Array,
    tableClass: String,
    showCheckbox: Boolean,
    totalRecords: Number,
    pageNumber: Number,
    pageSize: Number,
      actions: Array,
      //showIcon: {
      //    type: Boolean,
      //    required: false,
      //    default: false
      //},
      //iconFunc: {
      //    type: Function,
      //    required: false,
      //    default: () => 'fas fa-question'
      //},
      iconFuncs: {
          type: Array,
          required: false,
          default: () => []
      }
  },
  components: {
    DataList
  },
  data: () => {
    return {
        selectAll: false,
        selectedItem: null,
        selectedItems: [],

        selectedPageNumber: null
    }
  },
  watch: {
      getPageNumber(val) {
          this.selectedPageNumber = val
      }
  },
  computed: {
      getTotalRecords() {
          if (this.totalRecords) {
              return this.totalRecords
          }

          if (this.dataListItems && this.dataListItems[0]) {
              return this.dataListItems[0].totalRecords
          }
      },
      getPageNumber() {
          if (this.pageNumber) {
              return this.pageNumber
          }

          if (this.dataListItems && this.dataListItems[0]) {
              return this.dataListItems[0].pageNumber
          }
      },
      getPageSize() {
          if (this.pageSize) {
              return this.pageSize
          }

          if (this.dataListItems[0]) {
              return this.dataListItems[0].pageSize
          }
      },
      showPagination() {
          return (this.getTotalRecords && this.getPageSize) && this.getTotalRecords > this.getPageSize
      }
  },
  methods: {
      handlePagenationInput(payload) {
        if (payload) {
            this.$emit('pagination-input', payload)
        }
    },
    handleSelectedItemsChange(payload) {
        this.$emit('change', payload)
    },
    handleItemSglClick(payload) {
        this.$emit('sgl-click', payload)
    },
    handleItemDblClick(payload) {
        this.$emit('dbl-click', payload)
      },
      handleActionClick(payload) {
          this.$emit('action-click', payload)
      },
      handleSortClick(column) {
          this.$emit('column-click', column)
      }
  }
}
</script>

<style scoped>
</style>
